const mutations = {
  'SET_USERS' (state, { users }) {
    state.users = users
  }
}

export default mutations
